exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Faq-41188a90 h1{margin-bottom:10px}.Faq-41188a90 h2{font-size:18px;line-height:22px;font-weight:bold;margin-bottom:20px}.Faq-41188a90 hr{margin-top:30px;margin-bottom:30px}.Faq-41188a90 ul{margin-top:0}.Faq-41188a90 .contactUsLink-4eeae1f9{font-weight:500;font-size:13px}.Faq-41188a90 .itemHeader-5ee2c022{display:flex;justify-content:space-between;cursor:pointer}.Faq-41188a90 .itemHeader-5ee2c022 .icon-105561d9{color:#9E9E9E}\n", ""]);

// Exports
exports.locals = {
	"Faq": "Faq-41188a90",
	"contactUsLink": "contactUsLink-4eeae1f9",
	"itemHeader": "itemHeader-5ee2c022",
	"icon": "icon-105561d9"
};